import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=59b71ed2"
import script from "./ModuleSettings.vue?vue&type=script&lang=js"
export * from "./ModuleSettings.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettings.vue?vue&type=style&index=0&id=59b71ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports